import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Hero = () => {
    const heroStyle = {
        minHeight: '95vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        color: 'var(--white)',
        padding: '0 5%',
        position: 'relative',
        overflow: 'hidden',
        marginTop: '90px', // Reduced to 90px to aggressively remove gap
    };

    // Mobile-specific hero style adjustments
    const mobileHeroAdjustments = `
        @media (max-width: 768px) {
            .hero-section {
                margin-top: 45px !important; /* Reduced to 45px for mobile */
            }
        }
    `;

    // Determine if mobile based on window width
    // const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

    const bgStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundImage: 'url("/image-gen (5).png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed', // Fixed background as requested
        zIndex: 0
    };

    const contentVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.8, ease: "easeOut", staggerChildren: 0.2 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
    };

    return (
        <section className="hero-section" style={heroStyle}>
            {/* Mobile-specific styles */}
            <style>{mobileHeroAdjustments}</style>

            {/* Background Image */}
            <div className="hero-bg" style={bgStyle}></div>

            {/* Decorative overlay gradient */}


            {/* Hero Content Container */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                maxWidth: '1400px',
                gap: '60px',
                position: 'relative',
                zIndex: 2,
                flexWrap: 'wrap',
            }}>
                {/* Right Side - Brand Message */}
                <motion.div
                    className="hero-brand-message"
                    initial={{ opacity: 0, x: 50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    style={{
                        maxWidth: '500px',
                        flex: '1 1 400px',
                        background: 'transparent',
                        backdropFilter: 'blur(80px)',
                        padding: '40px',
                        borderRadius: '20px',
                        border: '1px solid rgba(255,255,255,0.2)',
                        boxShadow: 'none',
                        marginTop: '250px' // Moved down significantly per request
                    }}
                >
                    <p style={{
                        fontSize: '1.15rem',
                        lineHeight: '1.8',
                        color: '#000', // Color updated to #5B5B5B
                        margin: 0,
                        fontWeight: '300'
                    }}>
                        Nyssa is a trusted healthcare space offering compassionate, confidential, and Professional,evidence based care for female intimate health , hair, and skin. Here, you are heard first.
                    </p>
                </motion.div>
                {/* Left Side - Main Content */}
                <motion.div
                    className="hero-content"
                    style={{ maxWidth: '600px', textAlign: 'left', flex: '1 1 500px' }}
                    initial="hidden"
                    animate="visible"
                    variants={contentVariants}
                >

                    <motion.h1 variants={itemVariants} style={{
                        fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                        marginBottom: '25px',
                        color: '#fff',
                        lineHeight: '1.1',
                        fontFamily: 'var(--font-heading)',

                    }}>
                        Centre for Regenerative & <span style={{ color: '#fff' }}>Cosmetic Gynaeco-Dermatology</span>
                    </motion.h1>

                    <motion.p variants={itemVariants} style={{
                        fontSize: '1.3rem',
                        marginBottom: '50px',
                        color: '#fff',
                        opacity: '0.9',
                        fontWeight: '300',
                        maxWidth: '500px',
                        lineHeight: '1.6'
                    }}>
                        A calm, respectful space for healing & feeling like yourself again.
                    </motion.p>

                    <motion.div className="hero-buttons" variants={itemVariants} style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                        <Link to="/#book-appointment">
                            <motion.button
                                className="btn"
                                whileHover={{ scale: 1.05, backgroundColor: 'var(--primary)' }}
                                whileTap={{ scale: 0.95 }}
                                style={{
                                    backgroundColor: 'var(--white)',
                                    color: 'var(--secondary)',
                                    padding: '16px 40px',
                                    fontSize: '1rem',
                                    border: 'none',
                                    boxShadow: '0 10px 20px rgba(0,0,0,0.2)'
                                }}
                            >
                                Book a Private Consultation
                            </motion.button>
                        </Link>
                        <a href="tel:7070705590" style={{ textDecoration: 'none' }}>
                            <motion.button
                                className="btn"
                                whileHover={{ scale: 1.05, backgroundColor: 'var(--primary)' }}
                                whileTap={{ scale: 0.95 }}
                                style={{
                                    backgroundColor: 'var(--white)',
                                    color: 'var(--secondary)',
                                    padding: '16px 40px',
                                    fontSize: '1rem',
                                    border: 'none',
                                    boxShadow: '0 10px 20px rgba(0,0,0,0.2)'
                                }}
                            >
                                Speak to Our Expert
                            </motion.button>
                        </a>
                    </motion.div>
                </motion.div>


            </div>

            {/* Add floating animation keyframes */}
            <style>{`
                @keyframes float {
                    0%, 100% {
                        transform: translateY(0px);
                    }
                    50% {
                        transform: translateY(-10px);
                    }
                }

                /* Mobile Responsive Styles */
                @media (max-width: 768px) {
                    .hero-section {
                        padding: 0 20px !important;
                        min-height: 70vh !important;
                    }

                    .hero-bg {
                        background-image: url("/banner3.jpeg") !important;
                        background-attachment: scroll !important;
                    }

                    .hero-content {
                        max-width: 100% !important;
                        text-align: center !important;
                    }

                    .hero-content h1 {
                        font-size: 2rem !important;
                        margin-bottom: 20px !important;
                    }

                    .hero-content p {
                        font-size: 1.1rem !important;
                        margin-bottom: 30px !important;
                    }

                    .hero-buttons {
                        flex-direction: column !important;
                        align-items: center !important;
                        width: 100% !important;
                    }

                    .hero-buttons button {
                        width: 100% !important;
                        max-width: 300px !important;
                        padding: 14px 30px !important;
                        font-size: 0.9rem !important;
                    }

                    .hero-brand-message {
                        display: none !important;
                    }
                }
            `}</style>
        </section>
    );
};

export default Hero;
